
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'ajin-button-icon',
    templateUrl: './button.component.html',
    encapsulation: ViewEncapsulation.None
})

export class ButtonIconComponent {
    @Input() label: string | null = null;
    @Input() icon: string | null = null;
    @Input() color: string | null = null;
    @Input() size: 'sm' | 'md' | 'base' | 'lg' = 'sm';
    @Input() disabled: boolean = false;

    @Output() click = new EventEmitter<void>();

    constructor() {
    }


}


